import { z } from "zod";

export const notificationSettingSchema = z.object({
  creator: z.boolean(),
  personResponsible: z.boolean(),
  personAssisting: z.boolean(),
  otherStaffIds: z.array(z.string()),
  displayOtherStaff: z.boolean(),
});

export type NotificationSettingFormValues = z.infer<
  typeof notificationSettingSchema
>;
